module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS4zMyAxNC4zNzZhLjg5Ljg5IDAgMCAwIDEuMzQxIDBsMy4yNDEtNC4zNWEuNDQ1LjQ0NSAwIDAgMC0uMzU3LS43MDloLTcuMTFhLjQ0NC40NDQgMCAwIDAtLjM1Ni43MWwzLjI0IDQuMzQ5eiIgZmlsbD0iIzBDMEMwQyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/collapse-black.svg
// module id = lb8p
// module chunks = 3